import axios from 'axios';

export default function getCustomers(config) {
  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
    'x-location-id': localStorage.getItem('locationId')
  };
  const url = config.getCustomers;
  return dispatch => dispatch({
    type: 'CUSTOMERS_FETCH',
    payload: axios({ method: 'get', url, headers })
  })
}


// WEBPACK FOOTER //
// ./src/actions/getCustomers.js